import _ from 'lodash';

export const UNLIMITED_FEATURE_COUNT = 10000;

// Base features like "channels:10" and "channels:30" do not add up, we just pick the highest number
// However, you can also have additive features like "+channels:5" which add on top of the base number.
export function maxNumberOfFeatureType(type: string, features: ReadonlyArray<string>, defaultNum = 0) {
  const unlimitedType = `${type}:+`;
  const typeDefRe = () => new RegExp(`^${type}:(\\d+)$`);

  return _(features).reduce((m, feat) => {
    // "rules:+" or "rules" means nearly unlimited access.
    if (feat === unlimitedType) {
      return UNLIMITED_FEATURE_COUNT;
    }

    const res = typeDefRe().exec(feat);

    return res ? Math.max(Number(res[1]), m) : m;
  }, defaultNum);
}

export function isIntegrationUncounted(features: ReadonlyArray<string>, integrationId: string) {
  return features.includes(`int0:${integrationId}`);
}

export function hasFeature(feature: string, features?: ReadonlyArray<string>) {
  return (features || []).some((f) => f === feature || f.startsWith(`${feature}:`));
}
